import React from 'react'
import style from './AboutUs.module.scss'
import { useTranslation } from 'react-i18next'

export default function AboutUs() {
  const { t } = useTranslation();

  return (
    <div id="about" className={`${style.about}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className={`${style.item}`}>
              <div className={`${style.itemBorder}`}>
                <div className={`${style.img}`}>
                  <div className={`${style.overlay}`}>
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/profile.php?id=61557561129171" target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                      <li><i className="fa-brands fa-twitter" /></li>
                      <li><i className="fa-brands fa-instagram" /></li>
                      <li><i className="fa-brands fa-google" /></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className={`${style.aboutTitle}`}>
              <h2 className='mb-4'>{t('about.title')} <span>Solvix</span></h2>
              <p className='mb-4'>
                {t('about.description')}
              </p>
              <p className='mb-4'>
                {t('about.services.intro')}
              </p>
              <ul className='mb-4'>
                <li>{t('about.services.items.chemical')}</li>
                <li>{t('about.services.items.fibers')}</li>
                <li>{t('about.services.items.agricultural')}</li>
              </ul>
              <p className='mb-4'>
                {t('about.commitment')}
              </p>

              <h3 className='mt-5 mb-4'>{t('about.vision.title')}</h3>
              <p className='mb-4'>
                {t('about.vision.description')}
              </p>

              <h3 className='mt-5 mb-4'>{t('about.mission.title')}</h3>
              <p className='mb-4'>
                {t('about.mission.description')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
